export type VideoCategory = "movie" | "tv" | "short";

export interface Video {
  id: string;
  title: string;
  category: VideoCategory;
  categoryName: string;
  region: string;
  year: number;
  rating: number;
  duration: string;
  updatedAt: string;
  status: string;
  tags: string[];
  description: string;
  cover: string;
  backdrop: string;
  featured?: boolean;
}

export interface CategoryMeta {
  id: VideoCategory;
  name: string;
  short: string;
  description: string;
  icon: string;
}

export const categories: CategoryMeta[] = [
  {
    id: "movie",
    name: "电影",
    short: "精选院线大片与高分佳作",
    description: "浏览多多视频平台的电影影视资源，包含最新电影、高分佳作与经典回顾，覆盖科幻、剧情、动作、悬疑等多种类型。",
    icon: "ri-film-line",
  },
  {
    id: "tv",
    name: "电视剧",
    short: "热播剧集连续追更",
    description: "浏览多多视频平台的电视剧影视资源，包含最新剧集、热播好剧与口碑佳作，覆盖古装、都市、悬疑、家庭等多种题材。",
    icon: "ri-tv-2-line",
  },
  {
    id: "short",
    name: "短视频",
    short: "精彩短视频随时开刷",
    description: "浏览多多视频平台的短视频资源，包含科普、美食、生活、旅行等精彩短视频内容，碎片时间随时随地轻松观看。",
    icon: "ri-play-circle-line",
  },
];

export const videos: Video[] = [
  {
    id: "v1",
    title: "深海纪元",
    category: "movie",
    categoryName: "电影",
    region: "中国",
    year: 2024,
    rating: 9.2,
    duration: "128分钟",
    updatedAt: "2024-11-02",
    status: "已完结",
    tags: ["科幻", "冒险", "悬疑"],
    description: "当深海勘探队意外唤醒沉睡千年的古文明遗迹，人类文明的命运被重新书写，一场关于勇气、牺牲与未知世界的壮丽冒险就此展开。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%20of%20a%20deep%20ocean%20exploration%20adventure%2C%20moody%20dark%20teal%20and%20navy%20tones%2C%20stylized%20artistic%20illustration%2C%20light%20rays%20through%20water%2C%20minimal%20clean%20background%2C%20high%20detail&width=400&height=600&seq=ddv-cover-v1&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20deep%20ocean%20exploration%20vessel%20surrounded%20by%20glowing%20ancient%20underwater%20ruins%2C%20dark%20teal%20and%20navy%20atmosphere%2C%20volumetric%20light%20beams%20underwater%2C%20stylized%20film%20key%20art%2C%20dramatic%20and%20immersive&width=1600&height=900&seq=ddv-back-v1&orientation=landscape",
    featured: true,
  },
  {
    id: "v2",
    title: "长夜将明",
    category: "movie",
    categoryName: "电影",
    region: "中国",
    year: 2023,
    rating: 7.8,
    duration: "124分钟",
    updatedAt: "2024-08-18",
    status: "已完结",
    tags: ["剧情", "现实主义"],
    description: "一座北方小城的乡村医生在漫长冬夜里守护着最后一位病人，用微小的坚持对抗时代的洪流，讲述普通人不普通的温情故事。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20drama%20movie%20poster%20of%20a%20small%20northern%20town%20in%20deep%20winter%2C%20cold%20blue%20tones%20with%20a%20single%20warm%20window%20light%2C%20minimal%20stylized%20illustration%2C%20clean%20background%2C%20quiet%20emotional%20mood&width=400&height=600&seq=ddv-cover-v2&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20wide%20snowy%20northern%20town%20at%20dusk%20with%20warm%20glowing%20windows%2C%20cold%20blue%20and%20amber%20contrast%2C%20stylized%20artistic%20film%20key%20art%2C%20calm%20emotional%20atmosphere&width=1600&height=900&seq=ddv-back-v2&orientation=landscape",
    featured: false,
  },
  {
    id: "v3",
    title: "山海遗梦",
    category: "movie",
    categoryName: "电影",
    region: "中国",
    year: 2024,
    rating: 8.4,
    duration: "136分钟",
    updatedAt: "2024-10-12",
    status: "已完结",
    tags: ["奇幻", "古装", "冒险"],
    description: "取材于古老山海传说的奇幻冒险，少女与异兽结伴穿越迷雾之海，寻找传说中能实现愿望的神秘之城。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20fantasy%20movie%20poster%20of%20an%20ancient%20mythical%20journey%20across%20a%20misty%20sea%2C%20rich%20deep%20jade%20and%20gold%20tones%2C%20stylized%20artistic%20illustration%2C%20elegant%20minimal%20background%2C%20high%20detail&width=400&height=600&seq=ddv-cover-v3&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20epic%20fantasy%20landscape%20with%20misty%20sea%2C%20floating%20ancient%20mountains%20and%20glowing%20mythical%20creatures%2C%20jade%20green%20and%20gold%20tones%2C%20stylized%20painterly%20film%20key%20art%2C%20grand%20and%20dreamlike&width=1600&height=900&seq=ddv-back-v3&orientation=landscape",
    featured: true,
  },
  {
    id: "v4",
    title: "都市追风者",
    category: "movie",
    categoryName: "电影",
    region: "中国",
    year: 2024,
    rating: 8.1,
    duration: "116分钟",
    updatedAt: "2024-09-27",
    status: "已完结",
    tags: ["动作", "犯罪", "都市"],
    description: "一名退役赛车手被卷入地下竞速与商业阴谋的漩涡，只能用速度与勇气撕开黑暗，为自己的清白奋力一搏。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20action%20movie%20poster%20of%20a%20street%20racer%20in%20a%20neon-lit%20city%20at%20night%2C%20cool%20charcoal%20and%20orange%20accents%2C%20stylized%20bold%20illustration%2C%20clean%20dramatic%20background%2C%20high%20contrast&width=400&height=600&seq=ddv-cover-v4&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20wide%20night%20city%20street%20with%20neon%20light%20trails%20and%20a%20sports%20car%20in%20motion%2C%20cool%20charcoal%20tones%20with%20orange%20highlights%2C%20stylized%20film%20key%20art%2C%20fast%20energetic%20mood&width=1600&height=900&seq=ddv-back-v4&orientation=landscape",
    featured: false,
  },
  {
    id: "v5",
    title: "第七封信",
    category: "movie",
    categoryName: "电影",
    region: "韩国",
    year: 2023,
    rating: 8.9,
    duration: "110分钟",
    updatedAt: "2024-05-30",
    status: "已完结",
    tags: ["悬疑", "惊悚", "犯罪"],
    description: "退休警探收到六封来自不同年代的匿名信，当他拆开第七封信时，一桩尘封二十年的连环悬案重新浮出水面。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20thriller%20movie%20poster%20of%20an%20old%20sealed%20letters%20and%20a%20dim%20desk%20lamp%2C%20muted%20dark%20grey%20and%20deep%20red%20tones%2C%20stylized%20minimal%20illustration%2C%20tense%20mysterious%20mood%2C%20high%20detail&width=400&height=600&seq=ddv-cover-v5&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20dim%20study%20room%20with%20scattered%20old%20letters%20and%20a%20single%20lamp%20glow%2C%20muted%20dark%20grey%20and%20deep%20crimson%20tones%2C%20stylized%20noir%20film%20key%20art%2C%20tense%20atmosphere&width=1600&height=900&seq=ddv-back-v5&orientation=landscape",
    featured: true,
  },
  {
    id: "v6",
    title: "时光咖啡馆",
    category: "movie",
    categoryName: "电影",
    region: "日本",
    year: 2024,
    rating: 8.0,
    duration: "102分钟",
    updatedAt: "2024-07-15",
    status: "已完结",
    tags: ["爱情", "温情", "治愈"],
    description: "东京街角一家只在雨天营业的老咖啡馆，见证了无数次相遇与告别，也让两个错过多年的人重新坐到同一张桌前。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20romance%20movie%20poster%20of%20a%20cozy%20old%20cafe%20on%20a%20rainy%20day%2C%20warm%20amber%20and%20soft%20brown%20tones%2C%20stylized%20illustration%2C%20clean%20tender%20background%2C%20gentle%20emotional%20mood&width=400&height=600&seq=ddv-cover-v6&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20cozy%20corner%20cafe%20with%20rain%20on%20the%20window%20and%20warm%20hanging%20lights%2C%20amber%20and%20soft%20brown%20tones%2C%20stylized%20warm%20film%20key%20art%2C%20tender%20nostalgic%20atmosphere&width=1600&height=900&seq=ddv-back-v6&orientation=landscape",
    featured: false,
  },
  {
    id: "v7",
    title: "云都往事",
    category: "tv",
    categoryName: "电视剧",
    region: "中国",
    year: 2024,
    rating: 8.7,
    duration: "45分钟/集",
    updatedAt: "2024-10-28",
    status: "全45集",
    tags: ["古装", "权谋", "历史"],
    description: "一座云上皇城，三代朝堂风云。寒门书生凭一支笔踏入权力漩涡，在忠诚与野心之间艰难抉择，书写属于自己的传奇。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20historical%20chinese%20drama%20poster%20of%20a%20lone%20scholar%20before%20an%20ancient%20palace%2C%20deep%20ink%20blue%20and%20gold%20tones%2C%20stylized%20elegant%20illustration%2C%20minimal%20classic%20background%2C%20high%20detail&width=400&height=600&seq=ddv-cover-v7&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20ancient%20chinese%20imperial%20palace%20in%20clouds%20at%20dusk%2C%20deep%20ink%20blue%20and%20gold%20tones%2C%20stylized%20painterly%20film%20key%20art%2C%20grand%20solemn%20atmosphere&width=1600&height=900&seq=ddv-back-v7&orientation=landscape",
    featured: true,
  },
  {
    id: "v8",
    title: "星海舰队",
    category: "tv",
    categoryName: "电视剧",
    region: "美国",
    year: 2024,
    rating: 9.0,
    duration: "52分钟/集",
    updatedAt: "2024-11-05",
    status: "全32集",
    tags: ["科幻", "太空", "冒险"],
    description: "人类最后的星际舰队踏上寻找新家园的漫长航程，在浩瀚星海中面对未知文明、资源枯竭与船员之间的信任危机。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20space%20sci-fi%20series%20poster%20of%20a%20massive%20starship%20before%20a%20ringed%20planet%2C%20deep%20indigo%20and%20cyan%20tones%2C%20stylized%20illustration%2C%20clean%20cosmic%20background%2C%20high%20detail&width=400&height=600&seq=ddv-cover-v8&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20vast%20star%20fleet%20traveling%20through%20a%20nebula%20toward%20a%20distant%20planet%2C%20deep%20indigo%20and%20cyan%20tones%2C%20stylized%20epic%20film%20key%20art%2C%20awe%20inspiring%20cosmic%20mood&width=1600&height=900&seq=ddv-back-v8&orientation=landscape",
    featured: false,
  },
  {
    id: "v9",
    title: "迷雾侦探",
    category: "tv",
    categoryName: "电视剧",
    region: "英国",
    year: 2023,
    rating: 8.6,
    duration: "50分钟/集",
    updatedAt: "2024-09-10",
    status: "更新至24集",
    tags: ["悬疑", "推理", "犯罪"],
    description: "常年笼罩浓雾的港口城市接连发生离奇命案，一位患有失忆症的天才侦探用碎片般的记忆拼出令人震惊的真相。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20detective%20mystery%20series%20poster%20of%20a%20silhouette%20in%20thick%20fog%20with%20a%20lantern%2C%20cool%20grey%20and%20muted%20green%20tones%2C%20stylized%20minimal%20illustration%2C%20eerie%20mood%2C%20high%20detail&width=400&height=600&seq=ddv-cover-v9&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20foggy%20harbor%20city%20street%20at%20night%20with%20dim%20streetlamps%2C%20cool%20grey%20and%20muted%20green%20tones%2C%20stylized%20noir%20film%20key%20art%2C%20eerie%20mysterious%20atmosphere&width=1600&height=900&seq=ddv-back-v9&orientation=landscape",
    featured: false,
  },
  {
    id: "v10",
    title: "繁花盛开时",
    category: "tv",
    categoryName: "电视剧",
    region: "中国",
    year: 2024,
    rating: 8.3,
    duration: "44分钟/集",
    updatedAt: "2024-10-01",
    status: "全40集",
    tags: ["家庭", "都市", "情感"],
    description: "一座老宅院里的三姐妹，在时代变迁中守护着彼此，也守护着母亲留下的花圃。平凡日子里的酸甜苦辣，汇成最动人的生活长卷。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20family%20drama%20poster%20of%20a%20sunlit%20old%20courtyard%20blooming%20with%20flowers%2C%20warm%20rose%20and%20sage%20green%20tones%2C%20stylized%20warm%20illustration%2C%20clean%20tender%20background%2C%20high%20detail&width=400&height=600&seq=ddv-cover-v10&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20sunlit%20traditional%20courtyard%20filled%20with%20blooming%20flowers%20at%20golden%20hour%2C%20warm%20rose%20and%20sage%20green%20tones%2C%20stylized%20warm%20film%20key%20art%2C%20cozy%20nostalgic%20mood&width=1600&height=900&seq=ddv-back-v10&orientation=landscape",
    featured: false,
  },
  {
    id: "v11",
    title: "剑影流光",
    category: "tv",
    categoryName: "电视剧",
    region: "中国",
    year: 2024,
    rating: 8.5,
    duration: "46分钟/集",
    updatedAt: "2024-11-08",
    status: "更新至30集",
    tags: ["武侠", "江湖", "成长"],
    description: "江湖传闻的绝世剑谱重现人间，一名山村少年带着一柄断剑踏入纷争，在恩怨情仇中领悟真正的剑道与侠义。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20wuxia%20series%20poster%20of%20a%20swordsman%20silhouette%20against%20a%20misty%20mountain%2C%20deep%20ink%20and%20crimson%20tones%2C%20stylized%20elegant%20illustration%2C%20minimal%20background%2C%20high%20detail&width=400&height=600&seq=ddv-cover-v11&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20misty%20mountain%20gorge%20with%20a%20lone%20swordsman%20and%20falling%20leaves%2C%20deep%20ink%20and%20crimson%20tones%2C%20stylized%20wuxia%20film%20key%20art%2C%20dramatic%20poetic%20mood&width=1600&height=900&seq=ddv-back-v11&orientation=landscape",
    featured: false,
  },
  {
    id: "v12",
    title: "我们的青春纪事",
    category: "tv",
    categoryName: "电视剧",
    region: "中国",
    year: 2023,
    rating: 8.2,
    duration: "42分钟/集",
    updatedAt: "2024-06-20",
    status: "全36集",
    tags: ["青春", "校园", "成长"],
    description: "六个性格迥异的高中生在同一个夏天相遇，用欢笑、争吵和梦想记录下只属于他们的青春纪事，也留下永不褪色的友情。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20youth%20drama%20poster%20of%20students%20cycling%20down%20a%20tree-lined%20road%20in%20summer%2C%20bright%20sky%20blue%20and%20fresh%20green%20tones%2C%20stylized%20illustration%2C%20clean%20fresh%20background%2C%20high%20detail&width=400&height=600&seq=ddv-cover-v12&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20sunny%20tree-lined%20campus%20road%20in%20summer%20with%20students%20and%20dappled%20light%2C%20bright%20sky%20blue%20and%20fresh%20green%20tones%2C%20stylized%20warm%20film%20key%20art%2C%20youthful%20joyful%20mood&width=1600&height=900&seq=ddv-back-v12&orientation=landscape",
    featured: false,
  },
  {
    id: "v13",
    title: "一分钟看世界",
    category: "short",
    categoryName: "短视频",
    region: "中国",
    year: 2024,
    rating: 8.8,
    duration: "单集1分钟",
    updatedAt: "2024-11-09",
    status: "持续更新",
    tags: ["科普", "知识", "百科"],
    description: "用一分钟的动画与实景，带你读懂世界的奇妙知识。从微观粒子到浩瀚宇宙，每天一点新发现。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20educational%20short%20video%20cover%20with%20floating%20globe%20and%20science%20symbols%2C%20deep%20navy%20and%20bright%20cyan%20tones%2C%20stylized%20playful%20illustration%2C%20clean%20modern%20background%2C%20high%20detail&width=400&height=600&seq=ddv-cover-v13&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20abstract%20educational%20scene%20with%20floating%20planets%20atoms%20and%20data%20visualization%2C%20deep%20navy%20and%20bright%20cyan%20tones%2C%20stylized%20modern%20graphic%20key%20art%2C%20clean%20smart%20mood&width=1600&height=900&seq=ddv-back-v13&orientation=landscape",
    featured: true,
  },
  {
    id: "v14",
    title: "厨房小当家",
    category: "short",
    categoryName: "短视频",
    region: "中国",
    year: 2024,
    rating: 8.4,
    duration: "单集3分钟",
    updatedAt: "2024-11-07",
    status: "持续更新",
    tags: ["美食", "生活", "教程"],
    description: "三分钟学会一道家常好菜，从选材到出锅，手把手带你做出热气腾腾的人间烟火气。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20food%20short%20video%20cover%20of%20steaming%20homestyle%20dishes%20on%20a%20wooden%20table%2C%20warm%20orange%20and%20rich%20brown%20tones%2C%20stylized%20appetizing%20illustration%2C%20clean%20warm%20background%2C%20high%20detail&width=400&height=600&seq=ddv-cover-v14&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20close%20up%20of%20colorful%20homestyle%20dishes%20cooking%20with%20steam%20on%20a%20rustic%20table%2C%20warm%20orange%20and%20rich%20brown%20tones%2C%20stylized%20appetizing%20food%20key%20art%2C%20cozy%20inviting%20mood&width=1600&height=900&seq=ddv-back-v14&orientation=landscape",
    featured: false,
  },
  {
    id: "v15",
    title: "萌宠日常",
    category: "short",
    categoryName: "短视频",
    region: "中国",
    year: 2024,
    rating: 9.1,
    duration: "单集2分钟",
    updatedAt: "2024-11-10",
    status: "持续更新",
    tags: ["萌宠", "搞笑", "治愈"],
    description: "记录一群毛孩子的爆笑日常，治愈系的软萌瞬间每天准时上线，看完心情瞬间变好。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20cute%20pet%20short%20video%20cover%20with%20a%20fluffy%20kitten%20and%20puppy%20playing%2C%20soft%20pastel%20cream%20and%20baby%20blue%20tones%2C%20stylized%20adorable%20illustration%2C%20clean%20cheerful%20background%2C%20high%20detail&width=400&height=600&seq=ddv-cover-v15&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20cheerful%20scene%20of%20fluffy%20pets%20playing%20in%20a%20bright%20sunlit%20room%2C%20soft%20pastel%20cream%20and%20baby%20blue%20tones%2C%20stylized%20adorable%20key%20art%2C%20happy%20playful%20mood&width=1600&height=900&seq=ddv-back-v15&orientation=landscape",
    featured: false,
  },
  {
    id: "v16",
    title: "旅行者日记",
    category: "short",
    categoryName: "短视频",
    region: "法国",
    year: 2024,
    rating: 8.6,
    duration: "单集5分钟",
    updatedAt: "2024-11-04",
    status: "持续更新",
    tags: ["旅行", "风景", "纪录"],
    description: "跟随镜头走过山川湖海与小城街巷，用五分钟带你感受世界各地的风土人情与绝美风景。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20travel%20short%20video%20cover%20with%20a%20winding%20road%20through%20mountains%20at%20sunrise%2C%20golden%20and%20teal%20tones%2C%20stylized%20illustration%2C%20clean%20scenic%20background%2C%20high%20detail&width=400&height=600&seq=ddv-cover-v16&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20breathtaking%20travel%20landscape%20of%20mountains%20lake%20and%20an%20old%20town%20at%20sunrise%2C%20golden%20and%20teal%20tones%2C%20stylized%20scenic%20film%20key%20art%2C%20inspiring%20wanderlust%20mood&width=1600&height=900&seq=ddv-back-v16&orientation=landscape",
    featured: false,
  },
];

export const regions: string[] = ["全部", "中国", "美国", "英国", "日本", "韩国", "法国"];

export const years: string[] = ["全部", "2024", "2023"];

export const sortOptions = [
  { id: "hot", label: "热门" },
  { id: "update", label: "更新" },
  { id: "rating", label: "评分" },
];